import * as React from 'react';


var Icon = function (_a) {
    var children = _a.children, className = _a.className, height = _a.height, width = _a.width, viewBox = _a.viewBox, fill = _a.fill, onClick = _a.onClick;
    return (React.createElement("svg", { className: "Icon " + (className || ''), xmlns: "http://www.w3.org/2000/svg", onClick: onClick, height: height, width: width, viewBox: viewBox, fill: fill }, children));
};
export default React.memo(Icon);
